// src/Components/Forms/Financement/Salam/Validation/Tab2.tsx
import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { Space, Spin } from 'antd';
import Table from '../../../../TableResizable';
import { ColumnsType } from 'antd/es/table';
import ShowFile from '../../../../ShowFile';
import DataTypeTable from '../../../../../Types/DataTypeTable';
import InputForm from '../../../../InputT';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';

const Tab2 = (props: { form?: any; garantiesTableau: DataTypeTable[] }) => {
  const columns: ColumnsType<DataTypeTable> = [
    { title: 'Code Garantie', dataIndex: 'codgar' },
    { title: 'N° Identification', dataIndex: 'NUMIDENTI' },
    { title: 'Type', dataIndex: 'typgar' },
    { title: 'Valeur', dataIndex: 'VALGARANTI', render: (v) => formatNumber(v) + ' XAF' },
    { title: 'Couvert', dataIndex: 'valCouvert', render: (v) => formatNumber(v) + ' XAF' },
    { title: 'Désignation', dataIndex: 'DESIGNATION' },
    {
      title: 'Fichier',
      render: (_, r) =>
        r.fichier ? (
          <ShowFile file={r.fichier} fileName={r.codgar} />
        ) : (
          'Aucun'
        ),
    },
  ];

  const total = props.garantiesTableau.reduce((s, g) => s + (g.valCouvert || 0), 0);

  return (
    <Spin spinning={false}>
      <div className="tabItem">
        <Box fontStyle="inherit" className="border-left border" width={'85%'} position={'absolute'}>
          <legend>Garanties de financement</legend>
          <Table
            size="small"
            columns={columns}
            dataSource={props.garantiesTableau}
            pagination={{ pageSize: 5, position: ['bottomRight'] }}
            rowKey="codgar"
          />
          <InputForm
            notRequired
            money
            label="Valeur Totale de garantie"
            name="montantGarantieCouvert"
            disabled={true}
            type={'number'}
            value={total}
          />
        </Box>
      </div>
    </Spin>
  );
};

export default Tab2;